import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-notes', {
        url: '/shared-notes',
        component: 'companySharingCenterSharedNotes',
        resolve: {notes},
    });
}

/** @ngInject */
function notes( companyId, SharedAccountsService) {
    return SharedAccountsService
        .getAllCompanyNotes({companyId}).$promise;

}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/shared-notes.state.js